import { useSiteData } from '#shared/composables/useSiteData';

export function useSiteDataOnClient() {
  const { getNextPage, ...data } = useSiteData(useNuxtApp().payload.data || {});
  const newSiteData = data ? toRefs(reactive(data)) : data;

  return {
    ...newSiteData,
    getNextPage
  }
}
